<template>
  <div class="mb-4">

    <div class="row">
      <div class="col">
        <div class="alert alert-info" role="alert">
          <h4>You tried to purchase&hellip;</h4>
          <ul>
            <li><strong>Voucher:</strong> <span>{{ voucher.description }}</span></li>
            <li><strong>For:</strong> <span>{{ voucher.sale.total_amount | money }}</span></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-sm-6">
            <div class="alert alert-success" role="alert">
              <div class="input-group input-group-lg">
                <h4>Total Cost: <strong>{{ voucher.sale.total_amount | money }}</strong></h4>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="alert alert-primary text-center" role="alert" style="padding-top: 6px; padding-bottom: 6px;">
              <button class="btn btn-lg btn-primary" @click="takePayment">Try Payment Again</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <pay-handler
      ref="payComponent"
      :location="location"/>
  </div>
</template>

<script>
export default {
  props: {
    location: {
      type: Object,
      required: true,
    },
    voucher: {
      type: Object,
      required: true,
    },
  },

  methods: {
    takePayment() {
      this.$refs.payComponent.takeVoucherPayment(this.voucher);
    },
  },
}
</script>
